"use strict";

exports.__esModule = true;
exports.ChartItemsSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../../Core");
var _helper = require("../../../Widgets/MeasureChart/helper");
var _LayoutChartSelector = require("./LayoutChartSelector");
var _ChartTypeFieldsSelector = require("./ChartTypes/ChartTypeFieldsSelector");
var _constants = require("../../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ChartItemsSelector = exports.ChartItemsSelector = function ChartItemsSelector(props) {
  var _chartItems$props;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var elementEditor = props.elementEditor,
    path = props.path,
    _props$chartItems = props.chartItems,
    chartItems = _props$chartItems === void 0 ? {
      props: []
    } : _props$chartItems,
    blacklistItems = props.blacklistItems;
  var localChartItemsProps = (_chartItems$props = chartItems.props) == null ? void 0 : _chartItems$props.map(function (item) {
    return Object.assign({}, item);
  });
  var MAX_NUMBER_OF_CHARTS = 3;
  return /*#__PURE__*/_react["default"].createElement(_helper.Well, {
    "data-testid": "ChartItemsSelector"
  }, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("ChartItemsSelector.charts.label", "Charts")), /*#__PURE__*/_react["default"].createElement(_LayoutChartSelector.LayoutChartSelector, {
    path: path,
    elementEditor: elementEditor,
    chartItems: chartItems
  }), localChartItemsProps == null ? void 0 : localChartItemsProps.map(function (chartItem, index) {
    return /*#__PURE__*/_react["default"].createElement(_helper.Well, {
      key: "ChartItemsSelector-" + index
    }, /*#__PURE__*/_react["default"].createElement(_ChartTypeFieldsSelector.ChartTypeFieldsSelector, {
      path: path,
      elementEditor: elementEditor,
      chartItem: chartItem,
      itemIndex: index,
      blacklistItems: blacklistItems
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      text: translate("ChartItemsSelector.chartItemsRemove.label", "Remove chart"),
      "data-testid": "ChartItemsSelector.chartItemsRemove.button",
      icon: _icons.IconNames.REMOVE,
      onClick: function onClick() {
        localChartItemsProps.splice(index, 1);
        elementEditor.modifyElementAt(path, function (el) {
          return {
            item: "el.props.chartItems",
            value: el.props.chartItems = Object.assign({}, chartItems, {
              layout: (0, _LayoutChartSelector.getDefaultLayout)(localChartItemsProps.length),
              props: localChartItemsProps
            })
          };
        });
      }
    }));
  }), (localChartItemsProps == null ? void 0 : localChartItemsProps.length) < MAX_NUMBER_OF_CHARTS ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
    text: translate("ChartItemsSelector.chartItemsAdd.button", "Add chart"),
    "data-testid": "ChartItemsSelector.chartItemsAdd.button",
    icon: _icons.IconNames.ADD,
    onClick: function onClick() {
      localChartItemsProps.push({
        chartType: _constants.CHART_LINE
      });
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems",
          value: el.props.chartItems = Object.assign({}, chartItems, {
            layout: (0, _LayoutChartSelector.getDefaultLayout)(localChartItemsProps.length),
            props: localChartItemsProps
          })
        };
      });
    }
  }) : null);
};